import React from 'react';
import { ArrowRight } from 'lucide-react';

export function EmptyCanvasState() {
  return (
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
      <div className="text-center">
        <div className="flex items-center gap-3 text-gray-400 dark:text-gray-600 mb-2">
          <p className="text-lg font-medium">
            Drag widgets from the sidebar to get started
          </p>
          <ArrowRight size={32} className="animate-pulse" />
        </div>
        <p className="text-sm text-gray-500 dark:text-gray-500">
          Add Metric, Chart, Text, Media, or Embed widgets to your dashboard
        </p>
      </div>
    </div>
  );
}
